import { render, staticRenderFns } from "./ModalWithButtons.vue?vue&type=template&id=2e2b7ec1&"
import script from "./ModalWithButtons.vue?vue&type=script&lang=ts&"
export * from "./ModalWithButtons.vue?vue&type=script&lang=ts&"
import style0 from "./ModalWithButtons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports